import { useWallets } from '@shared/contexts/wallets-context';
import clsx from 'clsx';
import React from 'react';
import { general } from '../../constants/assets';

export const WalletChainButton: React.FC<{ type: 'checkout' | 'navbar' }> = ({ type }) => {
  const { openChainModal, chain } = useWallets();

  return (
    <button
      onClick={openChainModal}
      className={clsx(
        'font-border flex h-[42px] w-full items-center rounded-md duration-200 hover:bg-[#ECEAED33] hover:brightness-125 ',
        type === 'checkout' && 'my-0 w-auto border-2 border-[#ECEAED33] px-2 py-1 transition-all hover:brightness-125',
        type === 'navbar' && 'my-3 lg:my-0 lg:w-auto lg:border-2 lg:border-[#ECEAED33] lg:px-2 lg:py-1 lg:transition-all',
      )}
      type="button"
    >
      <div className="flex w-full items-center gap-2">
        {chain?.icon && (
          <div className="mr-1 size-[26px] overflow-hidden rounded-full">
            <img
              alt={chain.name ?? 'Chain icon'}
              src={chain.icon}
              className="size-[26px]"
            />
          </div>
        )}
        <div className={clsx(
          'lg:hidden',
          type === 'checkout' && 'hidden',
          type === 'navbar' && 'block',
        )}
        >
          {chain?.name}
        </div>
      </div>
      <img
        src={general.arrowDown}
        alt="arrow right"
        className="size-5"
      />
    </button>
  );
};
